import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import 'react-toastify/dist/ReactToastify.css';
/* Bootstrap e WowDash NON qui: rompono tipografia/layout del sito pubblico
   (docs/upgrade-2026/10_RESTYLING_SITO_PUBBLICO.md §2). Solo in AuthenticatedShell. */
import './styles/fonts.css';
import './styles/design-system.css';
import './styles/tailwind.css';
import './config/vc-theme.css';
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from 'react-toastify';
import ErrorBoundary from './components/ErrorBoundary';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Tree dell'app. Estratto in una const cosí lo usiamo sia per render (sviluppo) sia
// per hydrate (in produzione, quando react-snap ha già pre-renderizzato l'HTML al
// build-time e il browser deve solo "agganciare" gli event handler).
const appTree = (
  <HelmetProvider>
    <AuthProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </AuthProvider>
  </HelmetProvider>
);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  // HTML pre-renderizzato da react-snap: solo idratazione (no ri-render dell'intero markup).
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

reportWebVitals();
